import { useEffect } from 'react';
import { useLocale } from '../../../context/Localization/localization';
import { useFormikContext } from 'formik';
import { Locales } from '../../../context/Localization/localization.types';

/**
 * Allows for validation errors to be translated.
 * Can only be used within a Formik context.
 */
const useFormTranslateErrors: VoidFunction = () => {
    const { errors, setFieldTouched, touched } = useFormikContext<any>();
    const locale: Locales = useLocale();

    useEffect(() => {
        Object.keys(errors)
            .forEach((error) => {
                if (touched[error]) {
                    setFieldTouched(error, true);
                }
            });
    }, [errors, locale, setFieldTouched, touched]);
};

export default useFormTranslateErrors;